import { VAPID_KEY } from '@/const/app'
import { urlBase64ToUint8Array } from '@/utils/base64'

export async function initServiceWorker () {
  try {
    const registration = await navigator.serviceWorker.register('sw.js')
    console.log('SW ready: ', registration)

    const options = {
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_KEY)
    }

    return registration?.pushManager?.subscribe(options)
      .catch(error => {
        console.log('SW subscribe error: ', error)
      })
  } catch (error) {
    console.error('SW error: ', error)
  }
}
